import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useQueryClient } from '@tanstack/react-query'
import posthog from 'posthog-js'
import { StorageService } from '@/services/core/storage'
import { AuthService } from '@/services/core/auth'

const posthogConfigured = Boolean(
  import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN && import.meta.env.VITE_PUBLIC_POSTHOG_HOST
)

/** Signs the user out and returns to the login screen. */
export function useLogout() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useCallback(() => {
    if (posthogConfigured) posthog.reset()
    const currentUsername = StorageService.getCurrentUser()?.username
    if (!StorageService.getMasquerade() && !StorageService.getLastLoginUsername() && currentUsername) {
      StorageService.setLastLoginUsername(currentUsername)
    }
    StorageService.setMasquerade(null)
    AuthService.clearToken()
    StorageService.setCurrentUser(null)
    // Keep the currentUser query (and its observers) alive; just empty it.
    queryClient.setQueryData(['currentUser'], null)
    queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== 'currentUser' })
    navigate('/login')
  }, [navigate, queryClient])
}
